import { render, staticRenderFns } from "./records.vue?vue&type=template&id=644629b8&scoped=true"
import script from "./records.vue?vue&type=script&lang=js"
export * from "./records.vue?vue&type=script&lang=js"
import style0 from "./records.vue?vue&type=style&index=0&id=644629b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644629b8",
  null
  
)

export default component.exports